<script>
    import {flip} from 'svelte/animate';
    import AppIcon from "../components/icons/AppIcon.svelte";
    import OfferRoute from "./OfferRoute.svelte";
    import Alert from "../stores/alerts";

    export let offer;
    export let locations;
    export let tours;

    let editedRoute = null;
    let routeIndex = 1;
    let hovering = false;

    const setRoutesIndex = () => {
        routeIndex = 1;
        offer.routes.map(item => {
            item.index = routeIndex;
            routeIndex++;
        });
        offer.routes = offer.routes;
    }

    const addRoute = () => {
        editedRoute = {
            title: '',
            route_type: null,
            tour_id: null,
            pickups: [],
            destinations: [],
            prices: [],
            allow_schedule_date: 0,
        }
    }

    const editRoute = route => {
        editedRoute = route;
    }

    const closeEditRoute = data => {
        editedRoute = null;

        if (data) {
            if (!data.index) {
                offer.routes = [...offer.routes, data];
                setRoutesIndex();
            } else {
                let route = offer.routes.find(x => x.index == data.index);
                if (route) {
                    route.route_type = data.route_type;
                    route.tour_id = data.tour_id;
                    route.pickups = data.pickups;
                    route.destinations = data.destinations;
                    route.allow_schedule_date = data.allow_schedule_date;
                }
                offer.routes = offer.routes;
            }
        }
    }

    const removeRoute = route => {
        Alert.delete("Remove route", `Remove route from list?`, () => {
            offer.routes = offer.routes.filter(x => x.index != route.index);
        });
    }

    const dragstart = (event, i) => {
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.dropEffect = 'move';
        event.dataTransfer.setData('text/plain', i);
    }

    const drop = (event, target) => {
        event.dataTransfer.dropEffect = 'move';
        const start = parseInt(event.dataTransfer.getData("text/plain"));
        const newTracklist = offer.routes;

        if (start < target) {
            newTracklist.splice(target + 1, 0, newTracklist[start]);
            newTracklist.splice(start, 1);
        } else {
            newTracklist.splice(target, 0, newTracklist[start]);
            newTracklist.splice(start + 1, 1);
        }
        offer.routes = newTracklist;
        hovering = null;
    }

    setRoutesIndex();
</script>

<div class="legend mb-2">Routes</div>
<div class="d-flex flex-column gap-2">
    <table class="table table-list">
        <tbody>
        {#each offer.routes as item, index (item.index)}
            <tr class="row-hover" animate:flip="{{ duration: 100 }}"
                draggable={true}
                on:dragstart={event => dragstart(event, index)}
                on:drop|preventDefault={event => drop(event, index)}
                ondragover="return false"
                on:dragenter={() => hovering = index}
                class:drag-over={hovering === index}>
                <td class="p-2">
                    <button class="btn-reset is-link" on:click={() => editRoute(item)}>
                        {item.title}
                    </button>
                    {#if !item.prices || item.prices.length == 0}
                        <div class="text-danger">Route has no prices!</div>
                    {/if}
                </td>
                <td class="button-column p-1">
                    <button class="btn-reset btn-tool pt-1" title="remove route"
                            on:click={() => removeRoute(item)}>
                        <AppIcon icon="x" size="16"/>
                    </button>
                </td>
            </tr>
        {/each}
        </tbody>
    </table>
    <button class="btn btn-default py-2" on:click={addRoute}>Add route</button>
</div>

{#if editedRoute != null}
    <OfferRoute route={editedRoute} {locations} {tours} department_id={offer.department_id} onClose={closeEditRoute}/>
{/if}